import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../CustomModal";

const MemoryGameStartModal = forwardRef(({ onSubmit }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleConfirm = () => {
    onSubmit();
    setIsOpen(false);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={() => setIsOpen(false)}
      className="max-w-[45rem] rounded-2xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="px-2 py-6 md:px-10"
    >
      <h2 className="mb-6 text-center text-3xl font-bold text-blue-900">{t("memory_game.title")} 🎆</h2>

      <p className="mb-4 text-center text-xl font-semibold text-gray-800">
        <span className="text-yellow-500">{t("memory_game.goal_label")} </span>
        <span className="font-bold text-blue-500">{t("memory_game.goal_text")}</span>
      </p>

      <div className="text-gray-700">
        <p className="mb-4 text-lg font-semibold">{t("memory_game.how_to_play_title")} 🤔</p>

        <ol className="space-y-2 text-base">
          <li>
            <span className="font-bold text-blue-500">1.</span> {t("memory_game.step_1")}
          </li>
          <li>
            <span className="font-bold text-blue-500">2.</span> {t("memory_game.step_2")}
          </li>
          <li>
            <span className="font-bold text-blue-500">3.</span> {t("memory_game.step_3")}
          </li>
          <li>
            <span className="font-bold text-blue-500">4.</span> {t("memory_game.step_4")}
          </li>
          <li>
            <span className="font-bold text-blue-500">5.</span> {t("memory_game.step_5")}
          </li>
        </ol>

        <p className="mt-6 text-base text-gray-800">{t("memory_game.closing_note")} 😊</p>
      </div>

      <div className="mt-8 flex justify-center">
        <button
          onClick={handleConfirm}
          className="wavy-btn relative w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
        >
          {t("start")}
        </button>
      </div>
    </CustomModal>
  );
});

export default MemoryGameStartModal;
